'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReqQueryFeatureNames = undefined;

var _getQueryFeatureNames = require('./get-query-feature-names');

var getReqQueryFeatureNames = exports.getReqQueryFeatureNames = function getReqQueryFeatureNames() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      query = _ref.query;

  return !query ? [] : (0, _getQueryFeatureNames.getQueryFeatureNames)(query);
};